import Header from "../components/Header";
import Footer from "../components/Footer";

const About = () => {
  return (
    <div>
      <Header />
      <h1 className="page-heading">About</h1>
      <p className="page-paragraph">...</p>
      <Footer />
    </div>
  );
};

export default About;
